const locale ={
    HELP :"Help",
    PRIVACY:"Privacy",
    TERMS:"Terms",
}

export default locale